import { createContext } from 'react';

export const EventAssignmentLoadingContext = createContext(false);
export const EventAssignmentLoadingProvider = EventAssignmentLoadingContext.Provider;
